// Relocation transfers are created for Northern Textiles only (see lot-item-transfers.component.ts).
export const RELOCATION_SITE_PREFIX = 'NT.';
